export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4653.450804ef.jpg";